let user_name = null;
try{
    user_name = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).username;
}
catch(err){console.error("Error Parsing user_info username");}
const USER_NAME = user_name;


let token = null;
try{
    token = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).token;
}
catch(err){console.error("Error Parsing user_info token");}
const TOKEN = token;


let is_admin = null;
try{
    is_admin = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).is_admin;
}
catch(err){console.error("Error Parsing user_info is_admin");}
const IS_ADMIN = is_admin;


let user_id = null;
try{
    user_id = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).user_id;
}
catch(err){console.error("Error Parsing user_info user_id");}
const USER_ID = user_id;

let program_data = null;
try{
    program_data = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).program_data;
}
catch(err){console.error("Error Parsing user_info program_data");}
const PROGRAM_DATA = program_data;

const STRIP_DATA = {
    "allow_card_payment": false,
    "subscription_required": false,
    "allow_uploads": true,
    "allow_downloads": true,
    "allow_clipboard": true,
    "invite_only": true,
    "stripe_public_api_key": "pk_test_Q8aGzRsKZQVACZmBw562Dcbh",
    "google_recaptcha_public_key": "6Le5qy4UAAAAAGSsuiAYVhAm4b_YlKFTIeTgch2e",
    "welcome_message": "Welcome to Kasm. Click Desktop to enter your Kasm Desktop. The control panel will be on the left. When you are finished, you can chose to destroy your desktop or logout to preserve it. Your desktop will be preserved for up to 1 hour."
};

export default function stopReload(e) {
    e.preventDefault();
    e.returnValue = '';
}

export {
    USER_NAME,
    IS_ADMIN,
    USER_ID,
    TOKEN,
    STRIP_DATA,
    PROGRAM_DATA,
};


// WEBPACK FOOTER //
// ./src/constants/Constants.js